export default {
 CONTRACT:"0x895bbc29f74df77279bf585116caa24ce33ed0ba",
 RPC:"https://speedy-nodes-nyc.moralis.io/cf8b736636d60bdd2970f22a/eth/mainnet"
 
}